"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3ModalSettings = exports.WalletsMeta = void 0;
require("regenerator-runtime/runtime.js");
const connect_1 = __importStar(require("@crossmint/connect"));
const web3_provider_1 = __importDefault(require("@walletconnect/web3-provider"));
const walletlink_1 = __importDefault(require("walletlink"));
const constants_1 = require("@/constants");
const config_1 = __importDefault(require("../../config"));
const ABI = [];
const CONFIG = {
    chain: {
        decimal: 1
    },
    contractAddress: "0x29d7ebca656665c1a52a92f830e413e394db6b4f",
    contractABI: ABI,
    infuraId: "e08f25d6cba1481a8ea2cd2eb30fd267",
    network: "mainnet",
    networkUrl: "",
};
CONFIG.networkUrl = `https://${CONFIG.network}.infura.io/v3/${CONFIG.infuraId}`;
exports.WalletsMeta = {
    walletconnect: {
        name: "WalletConnect",
        icon: constants_1.Images.walletConnect
    },
    metamask: {
        name: "MetaMask",
        icon: constants_1.Images.metamaskWallet
    },
    coinbase: {
        name: "Coinbase",
        icon: constants_1.Images.coinbase
    },
    crossmint: {
        name: "Crossmint",
        icon: constants_1.Images.crossmint
    },
    trust: {
        name: "Trust",
        icon: constants_1.Images.trust
    },
};
exports.Web3ModalSettings = {
    network: CONFIG.network,
    cacheProvider: true,
    disableInjectedProvider: false,
    providerOptions: {
        walletconnect: {
            package: web3_provider_1.default,
            options: {
                infuraId: CONFIG.infuraId,
            },
        },
        "custom-walletlink": {
            package: walletlink_1.default,
            display: {
                name: "Coinbase",
                description: "Connect to Coinbase Wallet",
                logo: exports.WalletsMeta.coinbase.icon,
            },
            options: {
                appName: exports.WalletsMeta.coinbase.name,
                chainId: CONFIG.chain.decimal,
                networkUrl: CONFIG.networkUrl,
            },
            connector: () => __awaiter(void 0, void 0, void 0, function* () {
                const walletLink = new walletlink_1.default({ appName: "Coinbase" });
                const walletLinkProvider = walletLink.makeWeb3Provider(CONFIG.networkUrl, CONFIG.chain.decimal);
                yield walletLinkProvider.enable();
                return walletLinkProvider;
            }),
        },
        "custom-example": {
            display: {
                logo: exports.WalletsMeta.crossmint.icon,
                name: exports.WalletsMeta.crossmint.name,
                description: "Connect to your crossmint wallet"
            },
            package: connect_1.default,
            options: {
                apiKey: config_1.default.crossmintApiKey
            },
            connector: () => __awaiter(void 0, void 0, void 0, function* () {
                const _crossmintEmbed = new connect_1.CrossmintEVMWalletAdapter({
                    apiKey: config_1.default.crossmintApiKey,
                    chain: connect_1.BlockchainTypes.ETHEREUM, // BlockchainTypes.ETHEREUM || BlockchainTypes.POLYGON. For solana use BlockchainTypes.SOLANA
                });
                const address = yield _crossmintEmbed.connect();
                return {
                    isCrossmintWallet: true,
                    name: "Crossmint",
                    icon: "https://pbs.twimg.com/profile_images/1535656143988707330/Wg16GKQ2_400x400.png",
                    description: "Connect to your crossmint wallet",
                    address,
                    connector: _crossmintEmbed
                };
            })
        }
    },
};
